export default __webpack_public_path__ + "static/fresh-icons-9f61901fbcc1cd58e5baad8f8909435f.svg";